import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AnswerPage from '../pages/season1/AnswerPage';
import LoadingPage from '../pages/season1/LoadingPage';
import ResultPage from '../pages/season1/ResultPage';
import SelectPage from '../pages/season1/SelectPage';
import StartPage from '../pages/season1/StartPage';
import AnswerPage2 from '../pages/season2/AnswerPage2';
import LoadingPage2 from '../pages/season2/LoadingPage2';
import ResultPage2 from '../pages/season2/ResultPage2';
import SelectPage2 from '../pages/season2/SelectPage2';
import StartPage2 from '../pages/season2/StartPage2';

const Router = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<StartPage />}></Route>
				<Route path="/v2" element={<StartPage2 />}></Route>
				<Route path="/quiz" element={<SelectPage />}></Route>
				<Route path="/quiz2" element={<SelectPage2 />}></Route>
				<Route path="/loading" element={<LoadingPage />}></Route>
				<Route path="/loading2" element={<LoadingPage2 />}></Route>
				<Route path="/result/:score" element={<ResultPage />}></Route>
				<Route path="/result2/:score" element={<ResultPage2 />}></Route>
				<Route path="/answer" element={<AnswerPage />}></Route>
				<Route path="/answer2" element={<AnswerPage2 />}></Route>
			</Routes>
		</BrowserRouter>
	);
};

export default Router;
